export default {
  title: 'Create new password',
  content: 'Enter your information below',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  savePassword: 'Save password',
};
